/**
 *  Panel getters module file
**/

export const getters = {}
